import { render } from "./RightArrow.vue?vue&type=template&id=aa3b4372"
import script from "./RightArrow.vue?vue&type=script&lang=js"
export * from "./RightArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__